import { render, staticRenderFns } from "./PromotionPreviewProduct.vue?vue&type=template&id=79a09b50"
import script from "./PromotionPreviewProduct.vue?vue&type=script&lang=js"
export * from "./PromotionPreviewProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports